// Precalculation Warning modal component
import React, { useEffect } from "react";
import {
  EXCLUDED_INACTIVE_LIGHTHEADS_CALCULATION_INFO,
  EXCLUDED_INACTIVE_LIGHTHEADS_CONFIGUARTION,
  EXCLUDED_INACTIVE_LIGHTHEADS_INFO,
} from "../../CommonConstants";

const PreCalculationWrngModal = ({ continueCalculation }) => {
  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        continueCalculation(false);
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);
  return (
    <>
      <div id="preCalModal" className="m-auto">
        <div className="modal-dialog m-0">
          <div className="modal-content">
            <div className="close-icon text-end">
              <button type="button" className="close" data-dismiss="modal" onClick={() => continueCalculation("Close")}>
                <span aria-hidden="true">
                  <i className="fa fa-times text-red" />
                </span>
              </button>
            </div>
            <h2 className="modal-title text-white text-uppercase">Warning</h2>
            <div className="desc mb-5 mt-5">{EXCLUDED_INACTIVE_LIGHTHEADS_CONFIGUARTION}</div>
            <table className="table table-dark table-bordered" style={{ lineHeight: "1.5" }}>
              <tbody>
                <tr>
                  <td className="ver-al ps-0">
                    <button
                      type="button"
                      className="btn btn-red text-uppercase mt-0"
                      onClick={() => continueCalculation(true)}
                    >
                      Use Historic Data
                    </button>
                  </td>
                  <td className="ver-al">{EXCLUDED_INACTIVE_LIGHTHEADS_INFO}</td>
                </tr>
                <tr>
                  <td className="ver-al ps-0">
                    <button
                      type="button"
                      className="btn btn-red text-uppercase mt-0"
                      style={{ whiteSpace: "normal" }}
                      onClick={() => continueCalculation(false)}
                    >
                      Don’t Use Historic Data
                    </button>
                  </td>
                  <td className="ver-al">{EXCLUDED_INACTIVE_LIGHTHEADS_CALCULATION_INFO}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreCalculationWrngModal;
